import notify from '@/notify'
import config from '@/config'
import cordovaSpecificUtils from '@/specific-cordova/utils'
import defaultSpecificUtils from '@/specific-default/utils'
import Vue from 'vue'

let specificUtils

if (config.IS_CORDOVA_APP) {
  specificUtils = cordovaSpecificUtils
} else {
  specificUtils = defaultSpecificUtils
}

function getCookie (cname) {
  return specificUtils.getCookie(cname)
}

function setCookie (cname, cvalue, exdays, isGlobal) {
  specificUtils.setCookie(cname, cvalue, exdays, isGlobal)
}

function deleteCookie (cname, isGlobal) {
  specificUtils.deleteCookie(cname, isGlobal)
}

/*
function checkNetwork1() {
  return new Promise((resolve, reject) => {
    fetch(config.SERVER_DOMAIN + '/ping').then(resp => {
      resolve('PING SERVER WORKS');
    }, error => {
      resolve('PING SERVER FAILED');
    })
  });
}

function checkNetwork2() {
  return new Promise((resolve, reject) => {
    fetch('https://www.google.com', { mode: 'no-cors', headers: {'Cache-Control': 'no-cache' }}).then(resp => {
      resolve('PING GOOGLE WORKS');
    }, error => {
      resolve('PING GOOGLE FAILED');
    })
  });
}
*/

async function httpError (error) {
  let statusCode = Number(error.status)

  if (statusCode === 0) {
    // Már az interceptorban bekapcsoltuk az offline modal-t!
    return;
  }

  let msg = error.body.msg || 'Váratla hiba történt, próbálja meg ismét'
  if (statusCode === 403) {
    deleteCookie('userID')
    deleteCookie('token')
    //notify.warning("403: jogosultság hiba")
    //.then(() => {
    location.reload(true)
    //});
  } else if (statusCode === 520) {
    // notify.error(msg)
    notify.warning('Váratlan hiba történt, kérjük próbálja később')
  } else if (statusCode === 400) {
    notify.warning(msg)
  } else if (statusCode === 460) {
    location.reload(true)
  } else if (statusCode === 461) {
    notify.confirmation(msg)
      .then(() => {
        // yes
        Vue.http({
          url: config.SERVER_DOMAIN + '/api/guest/resendconfirmationemail',
          method: 'POST',
          body: JSON.stringify({ email: error.body.email }),
        }).then(response => {
          notify.success(response.body.msg)
        }, error => {
          httpError(error)
        })
      }, () => {
        // no
      })
  } else if (statusCode === 462) {
    notify.info(msg)
  } else if (statusCode === 470) {
    window.location.replace('/#/maintenance?msg=' + encodeURIComponent(msg))
  } else {
    // notify.error('unknown error')
    notify.warning('Váratlan hiba történt, kérjük próbálja később')
  }
}

function getDistance (lat1, lng1, lat2, lng2) {
  let pi = 0.017453292519943295
  let cos = Math.cos
  let calcHelper = 0.5 - cos((lat2 - lat1) * pi) / 2 +
    cos(lat1 * pi) * cos(lat2 * pi) *
    (1 - cos((lng2 - lng1) * pi)) / 2

  return 12742 * Math.asin(Math.sqrt(calcHelper))
}

function round (value, precision) {
  let multiplier = Math.pow(10, precision || 0)
  return Math.round(value * multiplier) / multiplier
}

function isEmailValid (email) {
  // eslint-disable-next-line
  let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regExp.test(email)
}

function isTourDone (tourName) {
  return Boolean(getCookie(tourName))
}

function setTourDone (tourName) {
  setCookie(tourName, true, 365)
}

function redirectBorgunPayment (url, borgunPostBody) {
  const method = 'post';
  const params = borgunPostBody

  let form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', url);

  for (let key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      let hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

export const getFormattedCurrency = (formatMe) => {
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF',
    maximumSignificantDigits: 3,
  }).format(formatMe)
}

export const logMeIn = (userID, token, isDigital) => {
  let oldUserId = getCookie('userID');
  //let oldToken = getCookie("token");
  setCookie(
    'userID',
    userID,
    300,
  );
  setCookie(
    'token',
    token,
    300,
  );
  setCookie(
    'isDigital',
    isDigital,
    300,
  );
  if (isDigital && (userID != oldUserId /*|| token != oldToken*/)) {
    window.location.reload();
  }
}

export {setTourDone, isTourDone}

export default {
  getCookie: getCookie,
  setCookie: setCookie,
  deleteCookie: deleteCookie,
  httpError: httpError,
  getDistance: getDistance,
  round: round,
  isEmailValid: isEmailValid,
  isTourDone: isTourDone,
  setTourDone: setTourDone,
  redirectBorgunPayment: redirectBorgunPayment,
}
